import React, { useState } from 'react';
import { AVATARS } from 'utils/avatars';
import Avatar from './avatar';
import { Check } from 'lucide-react';
import './avatar-selector.scss';

interface AvatarSelectorProps {
  selectedAvatar?: string;
  onSelect: (avatarName: string) => void;
  onSave?: () => void;
  loading?: boolean;
  className?: string;
}

const AvatarSelector: React.FC<AvatarSelectorProps> = ({
  selectedAvatar = '',
  onSelect,
  onSave,
  loading = false,
  className = ''
}) => {
  const [localSelected, setLocalSelected] = useState(selectedAvatar);

  const handleSelect = (avatarName: string) => {
    setLocalSelected(avatarName);
    onSelect(avatarName);
  };

  return (
    <div className={`avatar-selector ${className}`}>
      <h3 className="avatar-selector-title">Escolha um Avatar</h3>
      
      <div className="avatar-selector-grid">
        {AVATARS.map((avatar) => (
          <div
            key={avatar.name}
            className={`avatar-option ${localSelected === avatar.name ? 'avatar-option-selected' : ''}`}
            onClick={() => handleSelect(avatar.name)}
          >
            <Avatar 
              src={avatar.name} 
              alt={avatar.name}
              size="lg"
            />
            
            {localSelected === avatar.name && (
              <div className="avatar-option-check">
                <Check size={16} />
              </div>
            )}
          </div>
        ))}
      </div>

      {onSave && (
        <button 
          className="avatar-selector-save-btn"
          onClick={onSave}
          disabled={loading}
        >
          {loading ? 'Salvando...' : 'Salvar Avatar'}
        </button>
      )}
    </div>
  );
};

export default AvatarSelector;
